import { userInfo, userIdentity } from "@/api/user";
import { auth } from "common";
import { header } from "@/script/header";
const user = {
  state: {
    userFlag: false,
    userInfo: null,
    userName: "",
    userOrg: null, //当前用户组织机构信息
    orgCategoryUuid: "", //当前用户当前身份组织机构信息
    userRoles: [], //当前用户当前身份角色信息
    userIdentityList: [],
  },
  mutations: {
    SET_USER_FLAG: (state, flag) => {
      state.userFlag = flag;
    },
    //用户基本信息
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo || {};
      if (userInfo) {
        state.userName = userInfo.name || "";
      }
    },
    //当前用户身份列表
    SER_USER_IDENTITY_LIST: (state, identityList) => {
      state.userIdentityList = identityList;
    },
    //当前用户当前身份组织机构信息
    SET_USER_ORG: (state, org) => {
      state.userOrg = org || {};
      if (org) {
        state.orgCategoryUuid = org.orgCategoryUuid;
      }
      auth.configHeader(header(org));
    },
    //当前用户当前身份角色信息
    SER_USER_ROLES: (state, roleList) => {
      state.userRoles = roleList;
    },
  },
  actions: {
    /**获取用户基本信息 */
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        userInfo()
          .then((res) => {
            if (res.code === "00000") {
              let data = res.data && res.data.userDTO ? res.data.userDTO : null;
              let userInfo = JSON.parse(JSON.stringify(data));
              if (userInfo) {
                //删除用户组织机构信息，如需取组织机构信息，应获取当前人当前身份组织机构信息
                if (userInfo.orgs) {
                  delete userInfo.orgs;
                }
              }
              commit("SET_USER_INFO", userInfo);
              // let userOrg = {};
              // if (data.userDTO) {
              //   userOrg =
              //     data.userDTO.orgs && data.userDTO.orgs.length
              //       ? data.userDTO.orgs[0]
              //       : {};
              // }
              // let appOrg = data.appOrgDTOList;
              // let userIdentityInfoList = data.userIdentityInfoDTOS || [];

              commit("SET_USER_FLAG", true);
              resolve(data);
            } else {
              commit("SET_USER_FLAG", true);
              resolve({});
            }
          })
          .catch((error) => {
            commit("SET_USER_FLAG", true);
            reject(error);
          });
      });
    },
    /**获取用户身份列表、角色信息 */
    GetUserIdentity({ commit }, userUuid) {
      return new Promise((resolve, reject) => {
        auth.saveAppStorage("identity_info", {});
        userIdentity({
          userUuid: userUuid,
        })
          .then((res) => {
            if (res.code === "00000") {     
              let userIdentityList = res.data || [];
              let appOrg = null;
              if (userIdentityList.length) {
                let currentIdentityData = userIdentityList[0];
                //当前身份信息
                let identityInfo = currentIdentityData.identityOrgDTO;
                auth.saveAppStorage("identity_info", identityInfo);
                //当前身份组织机构信息
                appOrg = currentIdentityData.appOrgDTO;
                commit("SET_USER_ORG", appOrg);
                //当前身份角色信息
                let userRoleList = currentIdentityData.rolesDTOS || [];
                commit("SER_USER_ROLES", userRoleList);
              }
              commit("SER_USER_IDENTITY_LIST", userIdentityList);
              resolve([userIdentityList, appOrg]);
            } else {
              // commit("SER_USER_IDENTITY_LIST", []);
              resolve([]);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
export default user;
